<!-- <div *ngIf="message" [ngClass]="{ 'alert': message, 'alert-danger': message.type === 'warn',
 'alert-danger': message.type === 'error' }">{{message.text}}</div> -->
<!-- <p-message class="CallMessage" *ngIf="message&&isShown" severity="warn" id="CallMsg"
    text='A New Call Is Recieved Click Here To View It' closable="true" summary="Recieve Call"
    (click)="NavigateToCustomerSearchPage()">
</p-message> -->

<p-messages *ngIf="message && isShown" [(value)]="msgs" (click)="NavigateToCustomerSearchPage()" class="CallMsg"
    [enableService]="true" styleClass="CallMsgAlert" [closable]= "closeIcon">

</p-messages>




<!-- '<a href="#/customer/customersearch?SearchVal=${phone}" target="_blank"
    (click)="clear()"
    >A New Call Is Recieved Click Here To View It </a>'> -->